import { render, staticRenderFns } from "./LoginScreen.vue?vue&type=template&id=8753d63c&scoped=true"
import script from "./LoginScreen.vue?vue&type=script&lang=js"
export * from "./LoginScreen.vue?vue&type=script&lang=js"
import style0 from "./LoginScreen.vue?vue&type=style&index=0&id=8753d63c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8753d63c",
  null
  
)

export default component.exports